import React from 'react';
import { Section } from 'shared/sections/Section';
import { ArcadeRoomButtonAndPanel } from './button-and-panel';
import ArcadeRoomList from './list';
import './arcade-room.less';

interface Props {
    arcadeId: string;
}

const ArcadeRoomsSection = (props: Props) => (
    <Section
        className="arcade-cabinets-section"
        dark
        title="Arcade Rooms"
        titleAction={<ArcadeRoomButtonAndPanel />}
    >
        <ArcadeRoomList arcadeId={props.arcadeId} />
    </Section>
);
export default ArcadeRoomsSection;

